import React, { Fragment, useEffect, useState, } from 'react';
import { Col, Card, CardHeader, Table, Form, FormGroup, Label, Input, ModalFooter, Row } from 'reactstrap';
import { Btn } from '../../AbstractElements';
import { useDispatch, useSelector } from 'react-redux';
import CommonModal from '../../Components/Modals/modal';
import { addFaqs, getFaqs, updateFaqs, ModalToggle, isOpenModal, statusUpdateFaqs, deleteFaqs } from '../../store/faqsSlice';
import Pagination from '../../Components/Pagination/Pagination';
import SweetAlert from 'sweetalert2';
import Empty from '../../Components/Empty/Index';
 

const FaqsTable = () => {
  const storeVar = useSelector(state => state.faqs)
  const dispatch = useDispatch();
  const toggle = () => dispatch(ModalToggle());
  const [submit, setSubmit] = useState(false);
  const [formVar, setFormVar] = useState({
    keyword: '',
    limit: 10,
    offset: 0,
    currentPage: 1,
    modalTitle: null,
    editState: false,
    faqsId: null,
    question: '',
    answer: '',

  });

  useEffect(() => {
    dispatch(getFaqs(formVar.limit, formVar.offset))
  }, []);


  const searchState = (e) => {
    setFormVar((prevFormVar) => ({ ...prevFormVar, keyword: e.target.value }))
    dispatch(getFaqs(formVar.limit, formVar.offset, formVar.status, e.target.value))
  }
  const pageChange = (page) => {
    const offset = formVar.limit * (page - 1)
    setFormVar((prevFormVar) => ({
      ...prevFormVar,
      currentPage: page,
      offset: offset
    }))
    dispatch(getFaqs(formVar.limit, offset, formVar.status, formVar.keyword))
  };
  const EditToggleModal = (data) => {
    dispatch(isOpenModal(true))
    setFormVar((prevFormVar) => ({
      ...prevFormVar,
      editState: true,
      faqsId: data._id,
      question: data.question,
      answer: data.answer,
      modalTitle: 'Edit FAQ'
    }))
  }
  const AddToggleModal = () => {
    dispatch(isOpenModal(true))
    setFormVar((prevFormVar) => ({
      ...prevFormVar,
      question: '',
      answer: '',
      tag: '',
      editState: false,
      modalTitle: 'Add FAQ',
    }))
  }

  const submitFaq = () => {
    if (questionValid() || answerValid()) {
      setSubmit(true)
      return null
    }
    setSubmit(false)
    if (formVar.editState) {
      dispatch(updateFaqs({ id: formVar.faqsId, question: formVar.question, answer: formVar.answer }))
    } else {
      dispatch(addFaqs({ question: formVar.question, answer: formVar.answer}))
    }
  }


  const questionValid = () => {
    if (!formVar.question) {
      return "question name is required";
    }
  }
  const answerValid = () => {
    if (!formVar.answer) {
      return "Answer is required";
    }
  }
  const DeleteModel = (data) => {
    SweetAlert.fire({
      title: 'Are you sure?',
      text: 'Once deleted, you will not be able to recover this imaginary file!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Ok',
      cancelButtonText: 'cancel',
      reverseButtons: true
    })
      .then((result) => {
        if (result.value) {
          dispatch(deleteFaqs(data._id))

        }
      });
  }
  return (
    <Fragment>
      <Col sm='12'>
        <Card>
          <CardHeader>
            <Row>
              <Col md="5">
              </Col>
              <Col md="4">
              </Col>
              <Col md="3" className='d-flex justify-content-end align-items-center'>
                <div className="text-end border-2">
                  <Btn attrBtn={{ color: 'info-gradien', size: 'sm', onClick: AddToggleModal }}>
                    Add FAQ
                  </Btn>
                </div>
              </Col>
            </Row>

          </CardHeader>
          <div className='table-responsive'>
            <Table hover={true} className='table-border-horizontal table-light'>
              <thead>
                <tr>
                  <th scope='col'>Sl.No</th>
                  <th scope='col'>Question</th>
                  <th scope='col'>Answer</th>
                  <th scope='col'>Action</th>
                </tr>
              </thead>
              <tbody>
                {storeVar.faqsData?.map((item, index) => (
                  <tr key={item._id}>
                    <th scope='row'>{index + 1}</th>
                    <td>{item.question} </td>
                    <td>{item.answer}</td>
                    <td>
                      <div className='d-flex gap-2 align-items-center'>
                        <div className='cursor-pointer bg-light-primary font-primary action-icon'>
                        <i className="fa fa-edit fa-lg" onClick={(e) => EditToggleModal(item)}></i>
                        <div className="tooltipCustom">Edit</div>
                        </div>
                        <div className='cursor-pointer font-danger action-icon'>
                        <i className="fa fa-trash fa-lg" onClick={(e) => DeleteModel(item)}></i>
                        <div className="tooltipCustom">Delete</div>
                        </div>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
          {
            storeVar.totalFaq <= 0 && (
              <Empty />
            )
          }
        </Card>
        {
          storeVar.totalFaq > 0 &&
          <Pagination currentPage={formVar.currentPage} totalItem={storeVar.totalFaq}
            itemsPerPage={formVar.limit} showEllipsisAfter={true} visiblePageCount={3} onPageChange={pageChange} />
        }
      </Col>



      <CommonModal isOpen={storeVar.isOpenModal} title={formVar.modalTitle} toggler={toggle} >
        <Form>
          <FormGroup>
            <Label className="col-form-label" for="recipient-name">Question</Label>
            <Input className="form-control" type="text" placeholder='Enter Question' onChange={(e) => setFormVar((prevFormVar) => ({ ...prevFormVar, question: e.target.value }))} value={formVar.question} />
            {submit && questionValid() ? <span className='d-block font-danger'>{questionValid()}</span> : ""}
            <Label className="col-form-label" for="recipient-name">Answer</Label>
            <textarea className='form-control' name='description' rows='3' placeholder='Enter Answer' onChange={(e) => setFormVar((prevFormVar) => ({ ...prevFormVar, answer: e.target.value }))} value={formVar.answer} />
            {submit && answerValid() ? <span className='d-block font-danger'>{answerValid()}</span> : ""}

          </FormGroup>
        </Form>
        <ModalFooter>
          <Btn attrBtn={{ color: 'secondary', onClick: toggle }} >Close</Btn>
          <Btn attrBtn={{ color: 'primary', onClick: submitFaq }}>Save</Btn>
        </ModalFooter>
      </CommonModal>
    </Fragment>
  );
};

export default FaqsTable;
